<quill-editor
  class="editor-container"
  [modules]="quillModules"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [style.width]="editorWidth"
  [style.height]="editorHeight"
></quill-editor>
